<template>
  <nav class="dark">
    <div class="page-container">
      <router-link :to="{ name: lastPageName }"
                   class="button-close"
                   v-if="lastPageName && lastPageName !== 'menu'"
                   :title="buttonData.back">
        <svg>
          <use xlink:href="#closeSvg"></use>
        </svg>
      </router-link>
    </div>
    <div class="main-nav">
      <router-link :to="{ name: 'museum'}" :title="buttonData.menuMusuem">
        <div @click="closeMainNav" class="nav_item dark">
          <h3>
            <svg>
              <use v-if="selectedTranslation === 'en'" xlink:href="#logoMkSvgEng"></use>
              <use v-else xlink:href="#logoMkSvg"></use>
            </svg>
          </h3>
          <img src="@/assets/images/sections/museum.png" :alt="museumData.title" class="image-museum">
        </div>
      </router-link>
      <router-link :to="{ name: 'foundation'}" :title="buttonData.menuFoundaiton">
        <div @click="closeMainNav" class="nav_item light">
          <h3>
            <svg>
              <use v-if="selectedTranslation === 'en'" xlink:href="#logoFmkSvgEng"></use>
              <use v-else xlink:href="#logoFmkSvg"></use>
            </svg>
          </h3>
          <img src="@/assets/images/sections/foundation.png" :alt="foundationData.title" class="image-foundation">
        </div>
      </router-link>
      <router-link :to="{ name: 'centrum-edukacji'}" :title="buttonData.menuCentrum">
        <div @click="closeMainNav" class="nav_item dark">
          <h3>
            <svg>
              <use v-if="selectedTranslation === 'en'" xlink:href="#logoCentrumSvgEng"></use>
              <use v-else xlink:href="#logoCentrumSvg"></use>
            </svg>
          </h3>
          <img src="@/assets/images/sections/centrum.png" :alt="centrumData.title" class="image-centrum">
        </div>
      </router-link>
      <!-- <router-link :to="{ name: 'virtual'}" :title="buttonData.menuVirtual">
        <div @click="closeMainNav" class="nav_item dark">
          <h3>
            <svg>
              <use v-if="selectedTranslation === 'en'" xlink:href="#logoWmkSvgEng"></use>
              <use v-else xlink:href="#logoWmkSvg"></use>
            </svg>
          </h3>
          <img src="@/assets/images/sections/virtual.png" :alt="virtualData.title" class="image-centrum">
        </div>
      </router-link> -->
    </div>
  </nav>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'mainNavigation',
  methods: {
    ...mapActions([
      'toggleMainNav',
      'closeMainNav'
    ])
  },
  computed: {
    ...mapGetters([
      'museumData',
      'foundationData',
      'centrumData',
      'virtualData',
      'buttonData',
      'mainNavOpen',
      'lastPageName',
      'selectedTranslation'
    ])
  }
}
</script>

<style scoped lang="scss">
.button-close {
  color: $color-inverted;
  position: absolute;
  top: 31px;
  right: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  text-align: center;
  padding: 1px 6px;
  svg {
    width: 14px;
    height: 14px;
  }
}
.nav_item {
  text-transform: uppercase;
  text-align: left;
  position: relative;
  overflow: hidden;
  &:hover {
    img {
      transform: scale(1.1);
    }
    .image-centrum {
      transform: scale(1.07);
      @include mobile {
        transform: translateY(-50%) scale(1.07);
      }
    }
    h3 {
      transform: scale(1.05);
    }
  }
  h3 {
    position: absolute;
    top: 10vh;
    left: 0;
    padding: 40px 10% 40px 15%;
    max-width: 100%;
    font-size: $font-l;
    font-weight: normal;
    z-index: 10;
    transition: $transition;
    svg {
      height: auto;
      max-height: 80px;
      width: 100%;
      max-width: 296px;
    }
    strong {
      display: block;
      word-spacing: 30vw;
      font-size: $font-xl;
    }
  }
  img {
    position: absolute;
    z-index: 1;
    width: 80%;
    max-height: 60vh;
    top: 47vh;
    left: 10%;
    transition: $transition;
  }
  .image {
    &-foundation {
      left: auto;
      right: -2px;
    } // END .image-foundation;
    &-museum {
      margin-top: -10px;
    } // END .image-museum
    &-centrum {
      margin-top: -60px;
    } // END .image-centrum;
  }
  @include mobile {
    &:hover {
      img {
        transform: translateY(-50%) scale(1.1);
      }
    }
    h3 {
      top: 20px;
      left: 20px;
      // width: 40vw;
      padding: 0 20px;
      font-size: 12px;
      // margin: 30px 0 0;
      a:first-child & {
        top: -12px;
      }
      svg {
        max-height: 46px;
        max-width: 168px;
      }
      strong {
        font-size: 16px;
      }
    }
    img {
      max-width: 60vw;
      max-height: calc(33vh - 50px);
      width: auto;
      left: auto;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
    }
    .image {
      &-foundation {
        left: auto;
        right: -2px;
      } // END .image-foundation
      &-centrum {
        margin-top: 0;
      } // END .image-centrum
    }
  }
}
.dark {
  background-color: $bg-dark;
  color: $text-light;
}
.light {
  background-color: $bg-light;
  color: $text-dark;
}
.main-nav {
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99998;
  background-color: #fff;
  justify-content: space-between;
  overflow: hidden;
  a {
    width: 33.33%;
    height: 100%;
    div {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      align-content: center;
    }
  }
  @include mobile {
    background-color: transparent;
    flex-direction: column;
    height: calc(100% - 32px);
    top: 32px;
    // height: calc(100% - 64px);
    // top: 50%;
    // transform: translateY(-50%);
    a {
      width: 100%;
      height: calc(33.33vh - 32px);
      &:nth-child(2) {
        height: 33.33vh;
      }
      div {
        overflow: visible;
      }
    }
  }
}
.container {
  position: relative;
}
.main-nav-button {
  position: absolute;
  top: 10px;
  right: 0;
  width: 40px;
  height: 40px;
  transform: translateX(-20px);
  z-index: 99999;
  cursor: pointer;
  border: none;
  background-color: transparent;
  box-shadow: none;
  &:focus {
    outline: none;
  }
}
nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  a {
    display: block;
    font-weight: bold;
    color: $text-dark;
    // &.router-link-exact-active {
    //   .nav_item {
    //     color: $text-accent;
    //   }
    // }
  }
  .page-container {
    max-width: 88vw;
  }
  @include mobile {
    position: relative;
    height: 101vh;
    overflow-x: hidden;
    .page-container {
      position:fixed;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 999999;
      .button-close {
        top: 20px;
        right: 0;
      }
    }
  }
}
.hamburger {
    width: 40px;
    height: 40px;
    &:hover {
      span {
        background-color: $text-accent;
      }
    }
    .dark & {
      &:hover {
        span {
          background-color: $text-accent;
        }
      }
    }
    span {
      width: 80%;
      height: 2px;
      background-color: $text-dark;
      display: block;
      margin: 6px auto;
      .dark & {
        background-color: $text-light;
      }
    }
  }
</style>
